import { ComponentProps } from 'react';

import { HStack } from '@chakra-ui/react';

import FetchPayoffButton from './FetchPayoffButton';
import RequestPayoffButton from './RequestPayoffButton';

import { PermissionEnum } from '../../constants/permissions';
import { Can } from '../../libs/Can';

type RequestPayoffButtonProps = ComponentProps<typeof RequestPayoffButton>;
type FetchPayoffButtonProps = ComponentProps<typeof FetchPayoffButton>;

type PayoffRequestButtonsProps = {
  requestPayoffProps?: Omit<RequestPayoffButtonProps, 'size'>;
  fetchPayoffProps?: Omit<FetchPayoffButtonProps, 'size'>;
  size?: 'sm' | 'md' | 'lg';
};

const PayoffRequestButtons = ({
  requestPayoffProps,
  fetchPayoffProps,
  size = 'lg',
}: PayoffRequestButtonsProps) => {
  return (
    <Can I={PermissionEnum.RequestPayoff}>
      <HStack spacing={2}>
        <FetchPayoffButton {...fetchPayoffProps} size={size} />
        <RequestPayoffButton {...requestPayoffProps} size={size} />
      </HStack>
    </Can>
  );
};

export default PayoffRequestButtons;
